<template>
  <div class="notFound">
    <router-link class="logo" to="/">
      <img class="logo__icon" src="../../../assets/Top/logo_icon.svg" alt>
      <img class="logo__title" src="../../../assets/Top/logo_title.svg" alt>
    </router-link>
    <p>404 Page Not Found
      <br>ページが見つかりませんでした。
    </p>
    <router-link to="/hakodate">トップへ戻る</router-link>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style lang="scss" scoped>
$white: #fff;
$yellow: #eddb44;
$blue: #009898;

.notFound {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 72px;
  height: calc(100vh - 172px - 72px);
  padding: 0 16px;
  text-align: center;
  line-height: 2;
  font-weight: 500;
  font-size: 16px;
  .logo {
    display: flex;
    align-items: center;
    justify-content: center;
    display: none;
    width: 100%;
    height: 36px;
    text-decoration: none;
    &:first-child {
      margin-bottom: 40px;
    }
    &__icon {
      height: 100%;
    }
    &__title {
      height: 65%;
      &:not(:first-child) {
        margin-left: 12px;
      }
    }
    &:hover {
      .logo__icon {
        transition: transform 0.8s;
        transform-style: preserve-3d;
        transform: rotateY(360deg);
      }
    }
  }
  a {
    cursor: pointer;
    font-weight: 900;
    letter-spacing: 1px;
    &:not(:first-child) {
      margin-top: 1em;
      color: $blue;
    }
  }
}
@media screen and (min-width: 412px) and (max-width: 768px) {
  .notFound .logo {
    display: flex;
  }
}
@media screen and (max-width: 411px) {
  .notFound .logo {
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/NotFound/index.vue